/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './screen-guard.component.scss.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/forms';
import * as import3 from '@angular/common';
import * as import4 from '../../../app/screen-guard/screen-guard.component';
import * as import5 from '@angular/router';
import * as import6 from '../../../app/spinner/spinner.service';
import * as import7 from '../../../app/api/user.service';
import * as import8 from '../../../app/notification/notification.service';
const styles_ScreenGuardComponent:any[] = [import0.styles];
export const RenderType_ScreenGuardComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_ScreenGuardComponent,
  data: {}
}
);
function View_ScreenGuardComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),34,'div',[
      [
        'class',
        'screen-guard-container'
      ]
      ,
      [
        'tabindex',
        '0'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),31,'div',[[
        'class',
        'login-container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'h1',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Screen Locked'])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),25,'form',[
      [
        'class',
        'common-form'
      ]
      ,
      [
        'novalidate',
        ''
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngSubmit'
      ]
      ,
      [
        (null as any),
        'submit'
      ]
      ,
      [
        (null as any),
        'reset'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('submit' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,9).onSubmit($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('reset' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,9).onReset()) !== false);
        ad = (pd_1 && ad);
      }
      if (('ngSubmit' === en)) {
        const pd_2:any = ((<any>co.unlock()) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.ɵbf,([] as any[]),(null as any),(null as any)),
    import1.ɵdid(540672,(null as any),0,import2.FormGroupDirective,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]

    ]
      ,{form: [
        0,
        'form'
      ]
    },{ngSubmit: 'ngSubmit'}),
    import1.ɵprd(2048,(null as any),import2.ControlContainer,(null as any),[import2.FormGroupDirective]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatusGroup,[import2.ControlContainer],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'message'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        You have been inactive for 30 mins and your screen has been locked for security. Please reenter your password\n        below to resume your session. "if you refresh this page any unsaved changes will be lost"\n      '])),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'form-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'label',[[
        'for',
        'password'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'icon-lock'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[' PASSWORD'])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),5,'input',[
      [
        'autofocus',
        ''
      ]
      ,
      [
        'formControlName',
        'password'
      ]
      ,
      [
        'id',
        'password'
      ]
      ,
      [
        'placeholder',
        'Enter your password'
      ]
      ,
      [
        'type',
        'password'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,23)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,23).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,23)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,23)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import1.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.DefaultValueAccessor]),
    import1.ɵdid(671744,(null as any),0,import2.FormControlName,[
      [
        3,
        import2.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import1.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.FormControlName]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'button green'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Unlock'])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_7:any = co.form;
    ck(v,9,0,currVal_7);
    const currVal_15:any = 'password';
    ck(v,25,0,currVal_15);
  },(ck,v) => {
    const currVal_0:any = import1.ɵnov(v,11).ngClassUntouched;
    const currVal_1:any = import1.ɵnov(v,11).ngClassTouched;
    const currVal_2:any = import1.ɵnov(v,11).ngClassPristine;
    const currVal_3:any = import1.ɵnov(v,11).ngClassDirty;
    const currVal_4:any = import1.ɵnov(v,11).ngClassValid;
    const currVal_5:any = import1.ɵnov(v,11).ngClassInvalid;
    const currVal_6:any = import1.ɵnov(v,11).ngClassPending;
    ck(v,7,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_8:any = import1.ɵnov(v,27).ngClassUntouched;
    const currVal_9:any = import1.ɵnov(v,27).ngClassTouched;
    const currVal_10:any = import1.ɵnov(v,27).ngClassPristine;
    const currVal_11:any = import1.ɵnov(v,27).ngClassDirty;
    const currVal_12:any = import1.ɵnov(v,27).ngClassValid;
    const currVal_13:any = import1.ɵnov(v,27).ngClassInvalid;
    const currVal_14:any = import1.ɵnov(v,27).ngClassPending;
    ck(v,22,0,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14);
  });
}
export function View_ScreenGuardComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    import1.ɵqud(402653184,1,{eventsTarget: 0}),
    (l()(),import1.ɵeld(0,[
      [
        1,
        0
      ]
      ,
      [
        'eventsTarget',
        1
      ]

    ]
      ,(null as any),6,'div',[[
        'class',
        'screen-guard-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import3.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import1.ɵpid(131072,import3.AsyncPipe,[import1.ChangeDetectorRef]),
    import1.ɵpod(['protected']),
    (l()(),import1.ɵted((null as any),['\n  '])),
    import1.ɵncd((null as any),0),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n\n'])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),2,(null as any),View_ScreenGuardComponent_1)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import1.ɵpid(131072,import3.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import4.ScreenGuardComponent = v.component;
    const currVal_0:any = 'screen-guard-content';
    const currVal_1:any = ck(v,4,0,import1.ɵunv(v,2,1,import1.ɵnov(v,3).transform(co.lock$)));
    ck(v,2,0,currVal_0,currVal_1);
    const currVal_2:any = import1.ɵunv(v,10,0,import1.ɵnov(v,11).transform(co.lock$));
    ck(v,10,0,currVal_2);
  },(null as any));
}
function View_ScreenGuardComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-screen-guard',([] as any[]),(null as any),(null as any),(null as any),View_ScreenGuardComponent_0,RenderType_ScreenGuardComponent)),
    import1.ɵdid(245760,(null as any),0,import4.ScreenGuardComponent,[
      import5.Router,
      import6.SpinnerService,
      import7.UserService,
      import8.NotificationServiceBus,
      import1.NgZone
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const ScreenGuardComponentNgFactory:import1.ComponentFactory<import4.ScreenGuardComponent> = import1.ɵccf('app-screen-guard',import4.ScreenGuardComponent,View_ScreenGuardComponent_Host_0,{},{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9zY3JlZW4tZ3VhcmQvc2NyZWVuLWd1YXJkLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92ZXJjZWwvd29ya3BhdGgwL3NyYy9hcHAvc2NyZWVuLWd1YXJkL3NjcmVlbi1ndWFyZC5jb21wb25lbnQudHMiLCJuZzovLy92ZXJjZWwvd29ya3BhdGgwL3NyYy9hcHAvc2NyZWVuLWd1YXJkL3NjcmVlbi1ndWFyZC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9zY3JlZW4tZ3VhcmQvc2NyZWVuLWd1YXJkLmNvbXBvbmVudC50cy5TY3JlZW5HdWFyZENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJzY3JlZW4tZ3VhcmQtY29udGVudFwiIFtuZ0NsYXNzXT1cIntwcm90ZWN0ZWQ6IGxvY2skIHwgYXN5bmN9XCIgI2V2ZW50c1RhcmdldD5cbiAgPG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PlxuPC9kaXY+XG5cbjxkaXYgY2xhc3M9XCJzY3JlZW4tZ3VhcmQtY29udGFpbmVyXCIgKm5nSWY9XCJsb2NrJCB8IGFzeW5jXCIgdGFiaW5kZXg9XCIwXCI+XG4gIDxkaXYgY2xhc3M9XCJsb2dpbi1jb250YWluZXJcIj5cbiAgICA8aDE+U2NyZWVuIExvY2tlZDwvaDE+XG4gICAgPGZvcm0gY2xhc3M9XCJjb21tb24tZm9ybVwiIFtmb3JtR3JvdXBdPVwiZm9ybVwiIChuZ1N1Ym1pdCk9XCJ1bmxvY2soKVwiPlxuICAgICAgPHAgY2xhc3M9XCJtZXNzYWdlXCI+XG4gICAgICAgIFlvdSBoYXZlIGJlZW4gaW5hY3RpdmUgZm9yIDMwIG1pbnMgYW5kIHlvdXIgc2NyZWVuIGhhcyBiZWVuIGxvY2tlZCBmb3Igc2VjdXJpdHkuIFBsZWFzZSByZWVudGVyIHlvdXIgcGFzc3dvcmRcbiAgICAgICAgYmVsb3cgdG8gcmVzdW1lIHlvdXIgc2Vzc2lvbi4gXCJpZiB5b3UgcmVmcmVzaCB0aGlzIHBhZ2UgYW55IHVuc2F2ZWQgY2hhbmdlcyB3aWxsIGJlIGxvc3RcIlxuICAgICAgPC9wPlxuICAgICAgPGRpdiBjbGFzcz1cImZvcm0tZmllbGRcIj5cbiAgICAgICAgPGxhYmVsIGZvcj1cInBhc3N3b3JkXCI+PGkgY2xhc3M9XCJpY29uLWxvY2tcIj48L2k+IFBBU1NXT1JEPC9sYWJlbD5cbiAgICAgICAgPGlucHV0IGlkPVwicGFzc3dvcmRcIiB0eXBlPVwicGFzc3dvcmRcIiBwbGFjZWhvbGRlcj1cIkVudGVyIHlvdXIgcGFzc3dvcmRcIiBhdXRvZm9jdXMgZm9ybUNvbnRyb2xOYW1lPVwicGFzc3dvcmRcIiAvPlxuICAgICAgPC9kaXY+XG5cbiAgICAgIDxidXR0b24gY2xhc3M9XCJidXR0b24gZ3JlZW5cIj5VbmxvY2s8L2J1dHRvbj5cbiAgICA8L2Zvcm0+XG4gIDwvZGl2PlxuPC9kaXY+XG4iLCI8YXBwLXNjcmVlbi1ndWFyZD48L2FwcC1zY3JlZW4tZ3VhcmQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUNJQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7SUFBdUU7TUFDckU7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUE2QjtJQUMzQjtJQUFJO0lBQWtCO0lBQ3RCO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUE2QztRQUFBO1FBQUE7TUFBQTtNQUE3QztJQUFBO2dCQUFBO2dCQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFBO2dCQUFBO0lBQW1FO01BQ2pFO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBbUI7SUFHZjtNQUNKO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBd0I7TUFDdEI7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFzQjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXlCO0lBQWlCO0lBQ2hFO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7SUFBQTtnQkFBQTs7O01BQUE7UUFBQTs7TUFBQTs7SUFBQTtLQUFBO2dCQUFBO01BQUE7SUFBQTtnQkFBQTtNQUFBO1FBQUE7O01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTs7TUFBQTs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUE7Z0JBQUE7SUFBOEc7SUFDMUc7TUFFTjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTZCO0lBQWU7SUFDdkM7SUFDSDs7OztJQVpzQjtJQUExQixTQUEwQixTQUExQjtJQU9xRjtJQUFqRixVQUFpRixVQUFqRjs7SUFQSjtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFNBQUEscUVBQUE7SUFPSTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFVBQUEsMEVBQUE7Ozs7OztJQWRSO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFBOzs7OztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFrQztnQkFBQTtJQUFxRDtnQkFDckY7SUFBeUI7SUFDckI7SUFFTjtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFvQztJQWdCOUI7Ozs7SUFwQkQ7SUFBNkI7SUFBbEMsU0FBSyxVQUE2QixTQUFsQztJQUlvQztJQUFwQyxVQUFvQyxTQUFwQzs7Ozs7SUNKQTtnQkFBQTs7Ozs7O0lBQUE7S0FBQTs7O0lBQUE7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/screen-guard/screen-guard.component.ngfactory.ts